export default function Msg(
    message,
    type='success',
    verticalAlign = 'bottom', 
    horizontalAlign = 'center'
) {
  this.$notify({
    timeout: 1500,
    message,
    horizontalAlign: horizontalAlign,
    verticalAlign: verticalAlign,
    type,
  });
}
